import { render, staticRenderFns } from "./AnnualPlayerRanking2019.vue?vue&type=template&id=33c9ed4e&scoped=true"
import script from "./AnnualPlayerRanking2019.vue?vue&type=script&lang=js"
export * from "./AnnualPlayerRanking2019.vue?vue&type=script&lang=js"
import style0 from "./AnnualPlayerRanking2019.vue?vue&type=style&index=0&id=33c9ed4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c9ed4e",
  null
  
)

export default component.exports